import { PersonsMembershipsDTO } from "@/api/dto/PersonsMembershipsDTO";

export const ProgramTypes: Record<number, string> = {
  1: "Adult",
  2: "Junior",
  3: "UAP",
  4: "HS",
};

export interface IMembership {
  price: number | null;
  purchaseDate: string | null;
  startDate: string | null;
  expirationDate: string | null;
  type: string | null;
  program: string | null;
  voided: boolean;
  guestPrivileges: boolean;
  dto?: PersonsMembershipsDTO | null;
}

export class Membership implements IMembership {
  price;
  purchaseDate;
  startDate;
  expirationDate;
  type;
  program;
  voided;
  guestPrivileges;
  dto;

  constructor(config: IMembership) {
    this.price = config.price;
    this.purchaseDate = config.purchaseDate;
    this.startDate = config.startDate;
    this.expirationDate = config.expirationDate;
    this.type = config.type;
    this.program = config.program;
    this.voided = config.voided;
    this.guestPrivileges = config.guestPrivileges;

    this.dto = config.dto;
  }

  get isCurrent(): boolean {
    if (this.expirationDate) {
      return new Date() < new Date(this.expirationDate);
    }

    return false;
  }
}

/*

Example return from API:

{
    "assignId": 128550,
    "personId": 195565,
    "membershipTypeId": 1,
    "purchaseDate": "2024-05-14",
    "startDate": "2024-05-14",
    "expirationDate": "2025-05-15",
    "schoolId": null,
    "orderId": null,
    "price": 309,
    "createdOn": "2024-05-14",
    "createdBy": null,
    "updatedOn": "2024-05-15",
    "updatedBy": null,
    "temp": "N",
    "paymentLocation": "In-Person",
    "paymentMedium": "CC",
    "discountId": null,
    "oldCardNum": null,
    "oldCompReason": null,
    "oldDmgWaiver": null,
    "closeId": 3344,
    "ccTransNum": null,
    "groupId": null,
    "discountInstanceId": null,
    "notes": null,
    "voidCloseId": null,
    "discountAmt": null,
    "pretaxPrice": 309,
    "taxRate": 0,
    "ignoreDiscountFrozen": null,
    "originalExpirationDate": "null",
    "covidEmailSent": null,
    "covidDays": null,
    "memberhsipType": {
        "programId": 1,
        "membershipTypeName": "Full Year",
        "displayOrder": 1,
        "active": "Y",
        "createdOn": "2012-11-09",
        "createdBy": "JCOLE",
        "updatedOn": "2020-01-02",
        "updatedBy": "JCOLE",
        "duration": null,
        "expirationType": "Full Year",
        "price": 359,
        "oldDiscountType": null,
        "regCodeRowId": 1,
        "alertOnClose": "null",
        "gcEligible": "Y",
        "membershipTypeDisplayName": "Full Year Membership",
        "availableOnline": "Y",
        "canHaveGuestPrivs": "Y",
        "gcRegCodeRowId": 8,
        "ratingsRestricted": "null",
        "taxable": "null",
        "programPriority": 2,
        "renewalEligible": "Y"
    }
}
*/
